// extracted by mini-css-extract-plugin
export default {"linksContainer":"style_linksContainer__gH7sp","link":"style_link__1JPVd","btnContainer":"style_btnContainer__FHKv+"};